import rotateIcon from '../assets/images/360-icn.png';
import beetle from '../assets/images/beetle.png';
import blood from '../assets/images/blood.png';
import dustMite from '../assets/images/dustmite.png';
import petriDishImage from '../assets/images/petri-dish-1.png';
import pollen from '../assets/images/pollen.png';
import toad from '../assets/images/toad.png';
import bumpMap1 from '../assets/models/bump-maps/normal-noise-02.png';
import bumpMap2 from '../assets/models/bump-maps/normal-noise-03.jpg';
import branchedPlaceholder from '../assets/placeholders/branched.png';
import commaPlaceholder from '../assets/placeholders/comma.gif';
import rodPlaceholder from '../assets/placeholders/rod.png';
import BlueBackground from '../assets/images/bg_bacteria_blue.jpg';
import GreenBackground from '../assets/images/bg_bacteria_green.jpg';
import OrangeBackground from '../assets/images/bg_bacteria_orange.jpg';
import PurpleBackground from '../assets/images/bg_bacteria_purple.jpg';
import RedBackground from '../assets/images/bg_bacteria_red.jpg';


export const imagesToPreload = [
    rotateIcon,
    beetle,
    blood,
    dustMite,
    petriDishImage,
    pollen,
    toad,
    bumpMap1,
    bumpMap2,
    branchedPlaceholder,
    commaPlaceholder,
    rodPlaceholder,
    BlueBackground,
    GreenBackground,
    OrangeBackground,
    PurpleBackground,
    RedBackground
];


// WEBPACK FOOTER //
// ./src/config/images-to-preload.js